import { render, staticRenderFns } from "./ReleaseComplete.vue?vue&type=template&id=c9d562ce&scoped=true"
import script from "./ReleaseComplete.vue?vue&type=script&lang=js"
export * from "./ReleaseComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d562ce",
  null
  
)

export default component.exports